import { Ability } from '@casl/ability';

export default new Ability([
  {
    action: 'create',
    subject: 'Organization',
  },
  {
    action: 'delete',
    subject: 'Organization',
  },
  {
    action: 'create',
    subject: 'Alert',
  },
  {
    action: 'create',
    subject: 'Profile',
  },
  {
    action: 'create',
    subject: 'Invitation',
  },
  {
    action: 'create',
    subject: 'RegistrationCode',
  },
  {
    action: 'create',
    subject: 'EmailTemplate',
  },
  {
    action: 'delete',
    subject: 'Employee',
  },
]);
